export function tracklistIdForUserLikes(userId) {
  return `users/${userId}/likes`;
}

export function tracklistIdForUserTracks(userId) {
  return `users/${userId}/tracks`;
}



// WEBPACK FOOTER //
// ./src/core/users/utils.js